import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { SelectOption } from 'lib/components/types';
import { CustomCost } from 'types';
import classes from './index.module.scss';

interface Props {
	items: Array<CustomCost>;
	value?: number;
	setValue: React.Dispatch<React.SetStateAction<number | undefined>>;
	setLabel: React.Dispatch<React.SetStateAction<string | undefined>>;
	disabled?: boolean;
	selected: Array<number>;
}

const CustomCostSelect = ({ value, setValue, setLabel, disabled, items, selected }: Props) => {
	const [options, setOptions] = useState<SelectOption<number>[]>([]);
	const [option, setOption] = useState<SelectOption<number> | null>(null);

	useEffect(() => {
		if (items.length === 0) return;

		const all: SelectOption<number>[] = items.map(({ id, name }) => ({
			value: id,
			label: name,
		}));

		setOptions(all);
	}, [items]);

	useEffect(() => {
		if (selected.length === 0) return;
		const filtered: SelectOption<number>[] = items
			.filter((item) => !selected.includes(item.id))
			.map(({ id, name }) => ({
				value: id,
				label: name,
			}));

		setOptions(filtered);
	}, [selected]);

	useEffect(() => {
		if (value) {
			const item = items.find((item) => item.id === value)!;
			const option: SelectOption<number> = { label: item.name, value: item.id };
			setOption(option!);
		}
	}, [value]);

	const handleChange = (option: SelectOption<number> | null) => {
		setOption(option);
		setValue(option?.value);
		setLabel(option?.label);
	};

	return (
		<Select
			autoFocus
			isDisabled={disabled}
			placeholder="Select Custom Cost"
			className={classes['react-select-container']}
			classNamePrefix="react-select"
			options={options}
			isClearable={true}
			isSearchable={true}
			value={option}
			onChange={handleChange}
		/>
	);
};

export default CustomCostSelect;
